const Fullpage = {
  getters: {
    activeSection: state => state.activeSection,
  },
  state: {
    activeSection: 0,
  },
  mutations: {
    'FULLPAGE/GET_ACTIVE_SECTION': function(state, section) {
      state.activeSection = section;
    },
  },
};

export default Fullpage;
